import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent, SelectProps } from '@mui/material/Select';
import { useField } from 'formik';
import { FieldErrorMessage } from './FieldErrorMessage';

type Props = SelectProps<string> & {
  name: string;
  displayValidationError?: boolean;
};

export const AppSelectField = ({
  name,
  fullWidth,
  label,
  id,
  displayValidationError = false,
  ...restProps
}: Props) => {
  const [field, { error, touched }, { setTouched }] = useField(name);

  const handleChange = (e: SelectChangeEvent) => {
    void setTouched(true);
    field.onChange(e);
  };

  const showError = displayValidationError && !!error && touched;

  return (
    <FormControl
      data-testid={`${name}-select-field`}
      fullWidth={fullWidth}
      error={showError}
    >
      {label && <InputLabel id={id}>{label}</InputLabel>}
      <Select
        {...field}
        {...restProps}
        id={id}
        label={label}
        error={!!error && touched}
        sx={{
          '& .css-12geyt-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select':
            {
              whiteSpace: 'normal'
            }
        }}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: '40%' }
          }
        }}
        onChange={handleChange}
      />
      {showError && (
        <FormHelperText
          sx={{
            color: 'red',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <FieldErrorMessage name={name} />
        </FormHelperText>
      )}
    </FormControl>
  );
};
